import { render, staticRenderFns } from "./SecondGrabEngine.vue?vue&type=template&id=0cc1c0ca&scoped=true"
import script from "./SecondGrabEngine.vue?vue&type=script&lang=js"
export * from "./SecondGrabEngine.vue?vue&type=script&lang=js"
import style0 from "./SecondGrabEngine.vue?vue&type=style&index=0&id=0cc1c0ca&prod&lang=css"
import style1 from "./SecondGrabEngine.vue?vue&type=style&index=1&id=0cc1c0ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cc1c0ca",
  null
  
)

export default component.exports